module.exports = __webpack_public_path__ + "static/media/Study 02.5030d357.png";